import React from 'react';
import { FaGraduationCap, FaUniversity, FaUserMd, FaHeart } from 'react-icons/fa';
import { motion } from 'framer-motion';
import * as S from './About.styles';

const About: React.FC = () => {
  return (
    <S.AboutSection id="sobre-mi">
      <S.Container>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <S.SectionTitle as="h2">Sobre Mí</S.SectionTitle>
          <S.SectionSubtitle>
            Conoce mi formación y enfoque en medicina integral
          </S.SectionSubtitle>
        </motion.div>

        <S.ContentGrid>
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <S.PersonalInfo>
              <S.InfoTitle as="h3">
                <FaUserMd />
                Antecedentes Personales
              </S.InfoTitle>
              <S.InfoContent>
                <S.Name>Dra. Suni Wiphala Chipana Flores</S.Name>
                <S.Description>
                  Médica cirujana con formación integral en prevención, promoción, 
                  manejo y rehabilitación de la salud, con énfasis en la salud pública 
                  comunitaria y la integración de grupos de riesgo.
                </S.Description>
              </S.InfoContent>
            </S.PersonalInfo>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <S.AcademicInfo>
              <S.InfoTitle as="h3">
                <FaGraduationCap />
                Formación Académica
              </S.InfoTitle>
              <S.InfoContent>
                <S.Degree>
                  <FaUniversity />
                  Médica Cirujana
                </S.Degree>
                <S.Institution>
                  Facultad de Ciencias Médicas
                </S.Institution>
                <S.University>
                  Universidad de Santiago de Chile
                </S.University>
              </S.InfoContent>
            </S.AcademicInfo>
          </motion.div>
        </S.ContentGrid>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <S.PhilosophySection>
            <S.PhilosophyIcon>
              <FaHeart />
            </S.PhilosophyIcon>
            <S.PhilosophyTitle as="h3">Mi Filosofía de Atención</S.PhilosophyTitle>
            <S.PhilosophyText>
              Creo en una medicina integral que va más allá del tratamiento de síntomas. 
              Mi enfoque se centra en el acompañamiento personalizado, donde la comodidad 
              del paciente y su proceso de recuperación son fundamentales. Cada paciente 
              es único, y mi compromiso es brindar una atención humanizada que considere 
              todos los aspectos de su salud y bienestar.
            </S.PhilosophyText>
          </S.PhilosophySection>
        </motion.div>
      </S.Container>
    </S.AboutSection>
  );
};

export default About;